import React from 'react';

const ChartComponent = ({ render, focused, handleFocusClick }) => {
    return render ? <>{render(focused, handleFocusClick)}</> : <></>;
};

export const createComponente = (type, render, focused, handleFocusClick:Function) => {
    return <ChartComponent render={render} focused={focused} handleFocusClick={handleFocusClick} />;
};